import { Button, ButtonColors, ButtonVariants } from "@inno-ui/button";
import { CheckmarkIcon, HandThumbsDownLineIcon } from "@inno-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";

import type { ValidateSmartSchedulingSlotsData } from "../../api/smart-scheduling/smart-scheduling.types";

import styles from "./smart-scheduling.layout.module.scss";

type Props = {
  isValidatePending?: boolean;
  isBookPending?: boolean;
  isDeclinePending?: boolean;
  validateData?: ValidateSmartSchedulingSlotsData;
  children: React.ReactNode;
  onDecline?: () => void;
  onConfirm?: () => void;
  confirmDisabled?: boolean;
};

export function SmartSchedulingLayout({
  children,
  onDecline,
  onConfirm,
  confirmDisabled,
  validateData,
  isValidatePending,
  isBookPending,
  isDeclinePending,
}: Props) {
  const { t } = useTranslation();
  const selectionPossible
    = validateData?.selection_ok_for_common_slot
      && validateData?.selection_ok_for_guest;
  return (
    <div className={styles.smartSchedulingLayout}>
      {/* header */}
      <div className={styles.header}>
        <h1>
          {t("Please let us know your availability for the following meeting")}
        </h1>
      </div>
      {/* body */}
      <div className={styles.body}>{children}</div>
      {/* footer */}
      <div className={styles.footer}>
        <Button
          label={t("Decline")}
          variant={ButtonVariants.Ghost}
          color={ButtonColors.Red}
          icon={HandThumbsDownLineIcon}
          isLoading={isDeclinePending}
          onClick={onDecline}
        />
        <div className={styles.selectionContainer}>
          {!selectionPossible && !isValidatePending && !confirmDisabled && (
            <p className={styles.selectionText}>
              {t(
                "Your current selection would not lead to a possible appointment",
              )}
            </p>
          )}
          <Button
            label={t("Confirm")}
            variant={ButtonVariants.Dark}
            color={selectionPossible ? ButtonColors.Green : ButtonColors.Red}
            icon={CheckmarkIcon}
            disabled={confirmDisabled}
            isLoading={isValidatePending || isBookPending}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
}
